const filterUndefined = (data) => {
    return (Array.isArray(data) && data.filter(Boolean)) || data;
};
export default filterUndefined;
//# sourceMappingURL=filterUndefined.js.map